var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircleSolidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 0.833984C3.31325 0.833984 0.333252 3.81398 0.333252 7.50065C0.333252 11.1873 3.31325 14.1673 6.99992 14.1673C10.6866 14.1673 13.6666 11.1873 13.6666 7.50065C13.6666 3.81398 10.6866 0.833984 6.99992 0.833984ZM10.3333 9.89398L9.39325 10.834L6.99992 8.44065L4.60659 10.834L3.66659 9.89398L6.05992 7.50065L3.66659 5.10732L4.60659 4.16732L6.99992 6.56065L9.39325 4.16732L10.3333 5.10732L7.93992 7.50065L10.3333 9.89398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleSolidIcon);
export default __webpack_public_path__ + "static/media/CloseCircleSolidIcon.59f0a756.svg";
export { ForwardRef as ReactComponent };